export default "__VITE_ASSET__gIRZ31Pw__"